function state() {
  return {
    activeCampaigns: [],
    expiredCampaigns: [],
    campaign: {},
    channelData: {},
    categories: [],
    promotionCodes: {},
    prefixPromotion: "",
    campaignCombinations: [],
    dateRange: [],
    orderBy: "latest",
    productType: 0,
    activeTab: 0,
    searchInput: "",
    ruleEngineOption: "all",
  };
}

export default state;
